import { render, staticRenderFns } from "./fontsize.vue?vue&type=template&id=30f1e532&"
import script from "./fontsize.vue?vue&type=script&lang=js&"
export * from "./fontsize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports